import React from 'react'
import { IEffect } from '../../api/types/effect'
import { DamageStat } from './components/DamageStat/DamageStat'
import { DamageTranslation, WeaponProfTranslation } from '../../api/types/item'
import List from '@mui/material/List'
import { Box, Divider, ListItem, ListItemText, Typography } from '@mui/material'
import { ModifierNumber } from './components/ModifierNumber/ModifierNumber'
import { ModifierList } from './components/ModifierList/ModifierList'
import { BaseStatTranslation, SkillTranslation } from '../../api/types/character'

interface Props {
  effect: IEffect
  showTimedBanner?: boolean
}

export const Effect: React.FC<Props> = ({ effect, showTimedBanner = true }) => {
  return (
    <Box>
      {effect.timed && showTimedBanner && (
        <>
          <Divider />
          <Typography variant="button">{`Efekt czasowy (${effect.duration})`}</Typography>
          <Divider sx={{ marginBottom: '8px' }} />
        </>
      )}

      {effect.damage && (
        <DamageStat
          title={'Obrażenia'}
          entries={Object.entries(effect.damage || {})}
          translation={DamageTranslation}
        />
      )}

      {effect.damage_reduction && (
        <DamageStat
          title={'Redukcja obrażeń'}
          entries={Object.entries(effect.damage_reduction || {})}
          translation={DamageTranslation}
        />
      )}

      {effect.hit && (
        <List sx={{ padding: '0px', margin: '0px' }}>
          <ListItem sx={{ padding: '0px' }}>
            <ListItemText primary={'Trafienie'} />
            <ModifierNumber value={effect?.hit} />
          </ListItem>
        </List>
      )}
      {effect?.shield_block && (
        <List sx={{ padding: '0px', margin: '0px' }}>
          <ListItem sx={{ padding: '0px' }}>
            <ListItemText primary={'Blok'} />
            <ModifierNumber value={effect?.shield_block} />
          </ListItem>
        </List>
      )}
      {effect?.dodge && (
        <List sx={{ padding: '0px', margin: '0px' }}>
          <ListItem sx={{ padding: '0px' }}>
            <ListItemText primary={'Unik'} />
            <ModifierNumber value={effect?.dodge} />
          </ListItem>
        </List>
      )}

      <ModifierList
        translation={BaseStatTranslation}
        entries={Object.entries(effect?.base_stat || {})}
      />
      <ModifierList
        translation={SkillTranslation}
        entries={Object.entries(effect?.skill_stat || {})}
      />
      <ModifierList
        translation={WeaponProfTranslation}
        entries={Object.entries(effect?.weapon_proficiency || {})}
      />
    </Box>
  )
}
